import { render, staticRenderFns } from "./DraftingList.vue?vue&type=template&id=54bbc214&scoped=true"
import script from "./DraftingList.vue?vue&type=script&lang=ts"
export * from "./DraftingList.vue?vue&type=script&lang=ts"
import style0 from "./DraftingList.vue?vue&type=style&index=0&id=54bbc214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbc214",
  null
  
)

export default component.exports